/*
 * @Author: cc
 * @LastEditTime: 2021-05-14 16:00:46
 */
import Progress from "./progress";

export default Progress;
